export default "__VITE_ASSET__DmGABqLu__"